export function fmt(n: number): string {
  return n.toLocaleString("fr-FR");
}
